import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Layout, Menu, Icon} from 'antd'
import { Link } from 'react-router-dom'
import intl from 'react-intl-universal'

const { Sider } = Layout
const { SubMenu } = Menu
const MenuItem = Menu.Item

class SiderBar extends Component {
  constructor(props, context) {
    super(props, context)
    this.onCollapsed = this.onCollapsed.bind(this)
    this.state = {
      // ispc: this.IsPC(),
      // collapsed: !this.IsPC()
      collapsed: !props.ispc
    }
  }
  // IsPC() {
  //   const userAgentInfo = navigator.userAgent
  //   const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"]
  //   let flag = true
  //   for(let v = 0; v < Agents.length; v++) {
  //     if(userAgentInfo.indexOf(Agents[v]) > 0) {
  //       flag = false
  //       break
  //     }
  //   }
  //   return flag
  // }
  onCollapsed() {
    this.setState({
      collapsed: !this.state.collapsed
    })
  }
  render() {
    const { ispc } = this.props

    const userCenter = intl.get('USERCENTER')
    const buyProduct = intl.get('BUY_PRODUCT')
    const actionLog = intl.get('ACTION_LOG')
    const loginLog = intl.get('LOGIN_LOG')
    const buyLog = intl.get('BUY_LOG')
    const aboutAccount = intl.get('ABOUT_ACCOUNT')
    const editMsg = intl.get('EDIT_MSG')
    const aboutUs = intl.get('ABOUT_US')
    return (
      <Sider
        style={{ background: '#fff', zIndex: 1 }}
        breakpoint
        trigger={null}
        collapsible={ispc}
        // collapsible={this.state.ispc}
        collapsed={this.state.collapsed}
      >
        <Icon 
          className="trigger"
          type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
          onClick={ this.onCollapsed }
        />
        <Menu 
          mode="inline"
          defaultSelectedKeys={[this.props.location.pathname]}
        >
          <MenuItem key="/home/user">
            <Icon type="user" /><span>{userCenter}</span>
            <Link to="/home/user"></Link>
          </MenuItem>
          <MenuItem key="/home/view_goods">
            <Icon type="shop" />
            <span>{buyProduct}</span>
            <Link to="/home/view_goods"></Link>
          </MenuItem>
          <SubMenu title={<span><Icon type="file" /><span>{actionLog}</span></span>}>
            <MenuItem key="/home/login_log">
              <Link to="/home/login_log">{loginLog}</Link>
            </MenuItem>
            <MenuItem key="/home/purchase_log">
              <Link to="/home/purchase_log">{buyLog}</Link>
            </MenuItem>
          </SubMenu>
          <SubMenu title={<span><Icon type="edit" /><span>{aboutAccount}</span></span>}>
            <MenuItem key="/home/profile_update">
              <Link to="/home/profile_update">{editMsg}</Link>
            </MenuItem>
          </SubMenu>
          <MenuItem key="/home/about_us">
            <Icon type="message" />
            <span>{aboutUs}</span>
            <Link to="/home/about_us"></Link>
          </MenuItem>
        </Menu>
      </Sider>
    )
  }
  componentDidMount() {
    if(!this.props.ispc) {
      document.getElementsByClassName('trigger')[0].style.display = 'none'
    }
  }
}

const mapStateToProps = (state) => {
  return {
    ispc: state.auth.isPC
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(SiderBar)



// WEBPACK FOOTER //
// ./src/common/sider.js